import { decode, encode } from 'js-base64';

// Originally we used window.btoa() and window.atob() for converting to/from base64 respectively.
// Unfortunately, this doesn't work properly for latin characters (e.g. "€")
// See issue: https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte

export const encodeToBase64 = encode;
export const decodeFromBase64 = decode;
